exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__loading__3x3W2 {\n  -webkit-animation: styles__loading__3x3W2 1.5s linear infinite;\n          animation: styles__loading__3x3W2 1.5s linear infinite; }\n\n.styles__button__3Ri8b {\n  width: 115px;\n  font-size: toRem(12px); }\n\n@-webkit-keyframes styles__loading__3x3W2 {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes styles__loading__3x3W2 {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n", ""]);

// exports
exports.locals = {
	"loading": "styles__loading__3x3W2",
	"button": "styles__button__3Ri8b"
};